import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const Partners = () => {
  const mutualFunds = [
    "SBI Mutual Fund",
    "HDFC Mutual Fund",
    "ICICI Prudential Mutual Fund",
    "Aditya Birla Sun Life Mutual Fund",
    "Nippon India Mutual Fund",
    "Kotak Mahindra Mutual Fund",
    "Axis Mutual Fund",
    "UTI Mutual Fund",
    "DSP Mutual Fund",
    "Tata Mutual Fund",
    "Mirae Asset Mutual Fund",
    "Franklin Templeton Mutual Fund",
    "Bandhan Mutual Fund",
    "L&T Mutual Fund",
    "Invesco Mutual Fund",
    "Sundaram Mutual Fund",
    "PGIM India Mutual Fund",
    "Edelweiss Mutual Fund",
    "Canara Robeco Mutual Fund",
    "Mahindra Manulife Mutual Fund"
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-slate-50 to-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-amber-100 text-amber-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Our Partners
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            We Are Associated With
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Trusted partnerships with India's leading mutual fund houses to bring you the best investment opportunities
          </p>
        </div>

        {/* Mutual Fund Grid */}
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {mutualFunds.map((fund, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl p-4 border-2 border-slate-100 hover:border-amber-400 hover:shadow-lg transition-all duration-300 group"
              >
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-gradient-to-br from-amber-500 to-amber-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                    <CheckCircle2 className="text-white" size={18} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-slate-800 font-semibold text-sm leading-tight">
                      {fund}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Trust Badge */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-amber-50 to-amber-100 rounded-2xl px-8 py-6 border-2 border-amber-200">
            <p className="text-slate-700 font-semibold mb-2">
              📊 Access to <span className="text-amber-700 text-xl font-bold">1000+</span> Mutual Fund Schemes
            </p>
            <p className="text-slate-600 text-sm">
              Diversified portfolio options across equity, debt, hybrid, and thematic funds
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
